import React, { useEffect, useState } from "react";
import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
import { ReactComponent as EditIcon } from "../../../assets/svgs/edit-icon.svg";
import { ReactComponent as BackIcon } from "../../../assets/svgs/back-button.svg";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import CustomSwitch from "../../../components/Elements/CustomSwitch/CustomSwitch";
import { Tables } from "../../../components/Elements/Tables/Tables";
import CustomerAddQuestion from "./Roles/DIalogBoxes/CustomerAddQuestion";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const CustomerQuestionsTable = ({
  sectionId,
  subsectionId,
  setQuestionOpen,
  onClose,
  clientId,
}) => {
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Question", key: "question" },
    { label: "Type", key: "type" },
    { label: "Status", key: "status" },
    { label: "Action", key: "action" },
  ];

  const convertTableData = (question, index) => ({
    key: question._id,
    serial: <div>{index + 1}</div>,
    question: <div>{question.label}</div>,
    type: <div>{question.type}</div>,
    status: <div>-</div>,
    action: (
      <div className="flex justify-center gap-3 items-center">
        <GreenEye className="cursor-pointer" />
        <EditIcon
          className="cursor-pointer"
          onClick={() => setEditModalOpen(true)}
        />
        <CustomSwitch
          checked={question.status === "Active"}
          onChange={(checked) => console.log(`Status: ${checked}`)}
        />
      </div>
    ),
  });

  const fetchQuestions = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_CUSTOMER_ALL_CUSTOM_QUESTION(page, "", {
          customSubsectionId: subsectionId,
        }),
        headers: { client: clientId },
      });

      if (response.success) {
        const formattedData = response.data.map((q, idx) =>
          convertTableData(q, idx)
        );

        setTableData(formattedData);
      }
    } catch (error) {
      console.error("Failed to fetch questions:", error);
    }
  };

  useEffect(() => {
    if (subsectionId) {
      fetchQuestions();
    }
  }, [subsectionId, page]);

  return (
    <div className="w-full px-4">
      <div className="bg-white rounded-lg ">
        <div className="flex  px-6 items-center  pb-2">
          <BackIcon onClick={() => setQuestionOpen(false)} />
          <p className="text-[#06513D]  text-xl my-auto">Questions</p>
        </div>
        <div className="flex justify-between items-center mb-4 px-8">
          <div className="flex flex-col sm:flex-row gap-3 sm:items-center w-full sm:w-auto">
            <div className="px-6 sm:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm sm:text-base font-light whitespace-nowrap">
              Total Questions {tableData.length}
            </div>
            <SearchBar
              //   onSearch={(value) => setSearchTerm(value)}
              width="100%"
              className="w-full sm:w-[300px]"
            />
          </div>

          <CustomButton
            buttonType="primary"
            variant="ok"
            buttonText="+ ADD  QUESTION"
            className="text-sm h-[50px]"
            onClick={() => setAddModalOpen(true)}
          />
        </div>

        {!isMobile ? (
          <Tables
            data={tableData}
            headers={headers}
            current={page}
            total={tableData.length + (tableData.length === 10 ? 5 : 0)}
            onChange={setPage}
            pageSize={10}
          />
        ) : (
          <div className="space-y-4">
            {tableData.map((item) => (
              <div
                key={item.key}
                className="bg-white border border-gray-300 rounded-lg shadow-sm p-4"
              >
                <div className="flex justify-between text-sm mb-2">
                  <span className="font-semibold text-[#06513D]">Question</span>
                  <span>{item.question}</span>
                </div>
                <div className="flex justify-between text-sm mb-2">
                  <span>Type</span>
                  <span>{item.type}</span>
                </div>
                <div className="flex justify-between text-sm mb-2">
                  <span>Status</span>
                  <span>{item.status}</span>
                </div>
                <div className="flex gap-3 justify-end">
                  <GreenEye className="cursor-pointer" />
                  <EditIcon
                    className="cursor-pointer"
                    onClick={() => setEditModalOpen(true)}
                  />
                </div>
              </div>
            ))}
          </div>
        )}

        {addModalOpen && (
          <CustomerAddQuestion
            onOpen={addModalOpen}
            onClose={() => {
              setAddModalOpen(false);
              fetchQuestions();
            }}
            sectionId={sectionId}
            subSectionId={subsectionId}
            clientId={clientId}
            popupData={popupData}
            setPopupData={setPopupData}
            onSuccess={() => fetchQuestions()}
          />
        )}
        {/* 
        {editModalOpen && (
          <EditQuestion
            open={editModalOpen}
            onClose={() => setEditModalOpen(false)}
            sectionId={sectionId}
            subSectionId={subsectionId}
            onUpdate={() => fetchQuestions()}
          />
        )} */}
      </div>

      {popupData && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}
    </div>
  );
};

export default CustomerQuestionsTable;
